import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductETA extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateETA);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateETA);
  }

  /**
   * Updates the ETA.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateETA = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newETA = event.detail.data.html.querySelector('product-ETA');

    if (!newETA) return;

    morph(this, newETA, { childrenOnly: true });
  };
}

if (!customElements.get('product-eta')) {
  customElements.define('product-eta', ProductETA);
}
